<template>
  <div>
    <!-- 登录-->
    <Modal
      v-model="githave"
      width="500px"
      class-name="vertical-center-modal"
      @on-cancel="$emit('livets')"
      :mask-closable="false"
    >
      <div style="min-height: 300px; padding: 40px 60px">
        <div class="zhuce flex_left">
          <p @click="loading('formItem', 0)" :class="indexLive == 0 ? 'actives' : ''">
            短信登录
          </p>
          <p @click="loading('form_list', 1)" :class="indexLive == 1 ? 'actives' : ''">
            密码登录
          </p>
        </div>

        <div v-if="indexLive == 0" key="12">
          <Form ref="form_list" :model="form_list" :rules="ruleInfo" :label-width="0">
            <FormItem class="liItem" prop="phone">
              <img style="width: 22px; height: 25px" src="@/assets/image/inpone.png" />
              <Input
                height="50px"
                v-model="form_list.phone"
                placeholder="请输入您的手机号"
              >
              </Input>
            </FormItem>
            <FormItem class="liItem top_input" prop="password">
              <img style="width: 23px; height: 25px" src="@/assets/image/dui.png" />
              <Input
                style="height: 50px"
                v-model="form_list.password"
                placeholder="请输入动态密码">
              </Input>
              <Button
                v-show="codeList"
                @click="getCode('form_list')"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  width: 100px;
                  height: 45px;
                "
              >
                获取验证码
              </Button>
              <Button
                v-show="!codeList"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  width: 100px;
                  height: 45px;
                "
              >
                {{ times }}秒
              </Button>
              <div style="cursor: pointer; width: 33px" @click="register()">注册</div>
            </FormItem>
            <FormItem>
              <Button
                style="width: 100%; height: 40px"
                @click="nextList('form_list')"
                type="primary">
                登录
              </Button>
            </FormItem>
            <VerifyCode
              ref="verifyCode"
              :show="show"
              :phone="form_list.phone"
              @success="handleVerifySuccess"
              @close="handleVerifyClose" />
          </Form>
        </div>

        <div v-else-if="indexLive == 1" key="45">
          <Form ref="formItem" :model="formItem" :rules="formtimes" :label-width="0">
            <FormItem class="liItem" prop="phones">
              <img style="width: 21px; height: 23px" src="@/assets/image/anto.png" />
              <Input height="50px" v-model="formItem.phones" placeholder="请输入您的手机号" />
            </FormItem>
            <FormItem class="liItem myPasswordInput" prop="passwords">
              <img style="width: 21px; height: 23px" src="@/assets/image/suo.png" />
              <Input
                password
                type="password"
                style="height: 50px"
                placeholder="请输入密码"
                v-model="formItem.passwords"
              >
            </Input>
            </FormItem>
            <FormItem style="margin-bottom:10px !important">
              <div style="float: left; cursor: pointer" @click="register()">注册</div>
              <div class="passwor" style="width: 60px; float: right" @click="forget()">
                忘记密码
              </div>
            </FormItem>
            <FormItem>
              <Button
                style="width: 100%; height: 40px"
                @click="nextList('formItem')"
                type="primary"
                >登录</Button
              >
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <passwords :liveTop="liveTop" :comlist="comlist" @passwords="passWord"></passwords>
  </div>
</template>
<script>
import DataApi from "@/core/zwzsw_api/manage.js";
import {
  email,
  realName,
  select,
  upload,
  empty,
  phone,
  password,
  identity,
  verificationCode,
  pws,
  selectcity,
} from "@/core/charm/charm";
var vm;
import VerifyCode from "./verifyCode.vue";
import passwords from "./password.vue";
export default {
  props: ["dllogin"],
  name: "",
  data() {
    return {
      path: "",
      form_list: {
        phone: "",
        password: "",
      },
      comlist: 0,
      formItem: {
        phones: "",
        passwords: "",
      },
      ruleInfo: {
        phone: phone("你的手机号"),
        verifyStatus: [
          { validator: () => this.$refs.verifyRef.status, message: '请拖动滑块进行验证', trigger: 'blur'},
        ],
      },
      formtimes: { 
        phones: phone("你的手机号"), 
        passwords: empty("你的密码"),
        verifyStatus: [
          { validator: () => this.$refs.verifyRef1.status, message: '请拖动滑块进行验证', trigger: 'blur'},
        ],
      },
      indexLive: 0,
      liveTop: false,
      githave: this.dllogin,
      times: "", //验证码获取时间
      codeList: true,
      count: null,
      show: false,
    };
  },
  components: {
    VerifyCode,
    passwords: passwords,
  },
  watch: {
    dllogin(value) {
      this.dllogin = value;
      this.githave = value;
    },
    githave(value) {
      this.githave = value;
    },
    liveTop(value) {
      this.liveTop = value;
    },
    cancel: {
      header(value) {
        // vm.githave = false;
        vm.$emit("livets", vm.githave);
      },
      // this.$refs[name].resetFields();
    },
  },
  created() {
    vm = this;
  },
  mounted() {
    this.$root.Bus.$on("analy", function (msg, path) {
      // vm.dllogin = msg;
      vm.githave = msg;
      vm.path = path;
    });
  },

  methods: {
    handleVerifySuccess() {
      this.show = false;
      this.yanzheng();
    },
    handleVerifyClose () {
      this.show = false;
    },

    loading(name, index) {
      vm.indexLive = index;
      this.$refs[name].resetFields();
    },
    forget() {
      vm.liveTop = true;
      vm.githave = false;
      vm.$emit("livets", vm.githave);
    },
    cancel(name) {
      vm.githave = false;
      vm.$emit("livets", vm.githave);
    },
    passWord(index) {
      vm.liveTop = index;
      vm.comlist = 0;
      vm.dllogin = true;
      vm.githave = true;
    },
    async getCode(name) {
      var inputs = /^1[3456789]\d{9}$/;

      if(!vm.form_list.phone) {
        return this.$Message.error("请先输入手机号!");
      }

      if(!inputs.test(vm.form_list.phone)) {
        this.$Message.error("请输入正确的手机号!");
        return
      }

       // 校验手机号是否注册
       const res = await this.$apis.manage.accountIsExist({
          account: vm.form_list.phone,
        })
        if(res.data){
          this.$Message.error("该手机号未被注册");
          return 
        }
        if (this.times) return
        this.show = true;
    },
    yanzheng() {
      var data = {
        phone: vm.form_list.phone,
        adapter: "login",
      };
      this.$apis.manage
        .regiteList(data)
        .then((res) => {
          if (res.messageType == "Success") {
            this.$Message.success("发送成功！");
            const TIME_COUNT = 60;
            this.times = TIME_COUNT;
            this.codeList = false;
            this.times = 60;
            var count = setInterval(() => {
              this.times--;
              if (this.times <= 0) {
                this.codeList = true;
                clearInterval(count);
              }
            }, 1000);
          } else {
            this.$Message.error(res.resultDesc);
          }
        })
        .catch((err) => {});
    },
    register() {
      this.$root.Bus.$emit("livstop", true);
    },

    nextList(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var data = {};
          if (vm.indexLive == 0) {
            data = {
              username: vm.form_list.phone,
              validateCode: vm.form_list.password,
            };
          } else if (vm.indexLive == 1) {
            data = {
              password: vm.formItem.passwords,
              username: vm.formItem.phones,
            };
          }
          vm.logding(data);
        }
      });
    },
    // nextLists(name) {
    //   this.$refs[name].validate((valid) => {
    //     if (valid) {
    //       // var data = {
    //       //   username: "",
    //       //   validateCode: "",
    //       // };
    //       if (vm.indexLive == 0) {
    //         data = {
    //           username: vm.form_list.phone,
    //           validateCode: vm.form_list.password,
    //         };
    //       } else if (vm.indexLive == 1) {
    //         data = {
    //           password: vm.form_list.passwords,
    //           username: vm.form_list.phones,
    //         };
    //       }
    //       vm.logding(data);
    //     }
    //   });
    // },
    eventStatus() {
      let status = this.$store.state.eventStatus; 
      this.$store.commit("changeStatus", !status);
    },
    logding(data) {
      if (data.validateCode == "" || data.password == "") {
        this.$Message.error("密码或验证码必须填写");
        return;
      } else {
        this.$apis.manage
          .loginList(data)
          .then((res) => {
            if (res.messageType == "Success") {
              // vm.$emit("livets", vm.githave);
              this.$Message.success("登录成功");
              var token = res.data.token;
              var linkName = this.$store.state.linkName;
              window.sessionStorage.setItem("token", token);
              window.sessionStorage.setItem("userInfo", JSON.stringify(res.content));
              setTimeout(() => {
                if (vm.path) {
                  window.location.href = vm.path;
                } else {
                  window.sessionStorage.removeItem("liscity");
                  vm.githave = false;
                  if(linkName){
                      if(linkName == 'touGao' || linkName == 'jinDu') this.$store.state.linkType = true;
                      this.eventStatus();
                  }else{
                    location.reload();
                  }
                }
              }, 500); 
              //dneg
            } else {
              this.$Message.error(res.resultDesc);
            }
          })
          .catch((err) => {});
      }
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
.flex_left {
  display: flex;
  justify-content: space-between;
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
//
/deep/ .ivu-input {
  height: 45px;
  padding-left: 55px;
}
.zhuce {
  padding-top: 0px;
  padding-bottom: 30px;
  width: 50%;
  margin: 0 auto;
}
.zhuce p {
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  cursor: pointer;

  line-height: 24px;
}
.actives {
  font-weight: bold;
  color: #2150cb;
}
.liItem {
  position: relative;
}
.liItem img {
  display: block;
  position: absolute;
  top: 10px;
  left: 15px;
  z-index: 999999;
}
.myPasswordInput /deep/ .ivu-icon {
  font-size: 22px;
  line-height: 42px;
}
.top_input /deep/ .ivu-input {
  width: 240px;
}
/deep/.ivu-modal-footer {
  display: none;
}
.passwor {
  text-align: right;
  cursor: pointer;
}
</style>
